<div class="info-widget">
	<app-info [widget]="widget()" />
</div>
